/**
 * SimilarPlayersList — the similar-players list body.
 * @module features/player-detail/components/organisms/SimilarPlayersList
 */

export { default } from "./SimilarPlayersListView";
export type { SimilarPlayersListViewProps } from "./SimilarPlayersListView";
